<section id="terms-of-service" class="p-5">
  <h1>PK Spot - Terms of Service</h1>
  <p><em>Last Updated: 7th of February 2025</em></p>

  <h2>1. Introduction</h2>
  <p>
    Welcome to PK Spot ("Website"). By accessing or using this Website, you
    agree to these Terms of Service ("Terms"). If you do not agree to these
    Terms, please do not use the Website.
  </p>

  <h2>2. Ownership and Structure</h2>
  <p>
    This Website is operated by an individual. It is not incorporated, and the
    name "PK Spot" is not a registered trademark.
  </p>

  <h2>3. Acceptance of Terms</h2>
  <ul>
    <li>
      <strong>Registered Users:</strong> By signing up for an account, you
      expressly agree to these Terms.
    </li>
    <li>
      <strong>Visitors:</strong> Continued use of the Website (including viewing
      content) constitutes your acceptance of these Terms.
    </li>
  </ul>

  <h2>4. Use of the Website</h2>
  <p>
    You agree to use the Website in a lawful manner and not for any unlawful or
    prohibited activities. While you may browse publicly available content
    without signing in, certain features (such as account creation and posting
    content) require registration and explicit acceptance of these Terms.
  </p>

  <h2>5. User-Generated Content</h2>
  <p>
    You are solely responsible for any content you create, upload, or post. By
    posting content, you grant the Website operator a non-exclusive,
    royalty-free license to display and distribute your content on the Website.
  </p>

  <h2>6. Intellectual Property</h2>
  <p>
    All content on this Website (except for user-generated content) is the
    property of the Website operator. No part of this Website, including its
    design or text, may be copied or reproduced without express permission.
  </p>

  <h2>7. Disclaimers and Limitations of Liability</h2>
  <p>
    The Website and its content are provided "as is" without any warranties,
    express or implied. The operator is not liable for any damages arising from
    the use or inability to use the Website, including any loss of data or
    profits. As this is a first version of the Website, features and content may
    change without notice.
  </p>

  <h2>8. Modifications to Terms</h2>
  <p>
    These Terms may be updated or modified at any time. The updated Terms will
    be posted on this page, and your continued use of the Website will
    constitute acceptance of any changes.
  </p>

  <h2>9. Contact Information</h2>
  <p>
    If you have any questions about these Terms, please contact us at:<br />
    Email:
    <a href="mailto:contact@lukasbuehler.ch">contact{{ "@" }}lukasbuehler.ch</a
    ><br />
  </p>
</section>
